export default __webpack_public_path__ + "static/media/gallery.8c931538.svg";